import { graphql } from "@/gql";

export const incidentWorkOrderOptionQuery = graphql(`
  query IncidentWorkOrderOption($id: ID!) {
    workOrder(id: $id) {
      ...IncidentWorkOrderOptionFields
    }
  }
`);
